"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TgglProvider = exports.useTggl = void 0;
const react_1 = __importStar(require("react"));
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const TgglReactContext = react_1.default.createContext({});
let counter = 0;
const useTggl = () => (0, react_1.useContext)(TgglReactContext);
exports.useTggl = useTggl;
let amplitude = null;
try {
    amplitude = require('@amplitude/analytics-browser');
}
catch (e) {
    // ignore
}
const defaultOnFlagEvaluation = (opts) => {
    if (amplitude) {
        amplitude.track('[Tggl] Flag evaluated', opts);
    }
};
const TgglProvider = ({ children, client, initialContext = {}, onFlagEvaluation = defaultOnFlagEvaluation, }) => {
    const ref = (0, react_1.useRef)({
        context: initialContext,
        loading: 0,
        loadedOnce: false,
        error: null,
        onChange: new Map(),
        onFlagEvaluation,
    });
    ref.current.onFlagEvaluation = onFlagEvaluation;
    const setContext = (0, react_1.useCallback)((context) => {
        ref.current.context = context;
        ref.current.loading++;
        ref.current.loadedOnce = true;
        ref.current.error = null;
        for (const callback of ref.current.onChange.values()) {
            callback();
        }
        client
            .setContext(context)
            .catch((error) => {
            ref.current.error = error;
        })
            .then(() => {
            ref.current.loading--;
            for (const callback of ref.current.onChange.values()) {
                callback();
            }
        });
    }, [client]);
    const value = (0, react_1.useMemo)(() => ({
        client,
        setContext,
        updateContext: (context) => setContext(Object.assign(Object.assign({}, ref.current.context), context)),
        getLoading: () => ref.current.loading > 0 && !ref.current.loadedOnce,
        getError: () => ref.current.error,
        onChange: (callback) => {
            const key = String(counter++);
            ref.current.onChange.set(key, callback);
            return () => ref.current.onChange.delete(key);
        },
        trackFlagEvaluation: (slug) => ref.current.onFlagEvaluation({
            slug,
            active: client.isActive(slug),
            value: client.get(slug, null),
        }),
    }), [client, setContext]);
    (0, react_1.useEffect)(() => {
        setContext(initialContext);
        // We do not want to trigger this effect everytime the initialContext changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setContext]);
    (0, react_1.useEffect)(() => {
        return client.onResultChange(() => {
            for (const callback of ref.current.onChange.values()) {
                callback();
            }
        });
    }, [client]);
    return (react_1.default.createElement(TgglReactContext.Provider, { value: value }, children));
};
exports.TgglProvider = TgglProvider;
//# sourceMappingURL=TgglProvider.js.map